<template>
  <div id="app">
     <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- <evaluate ref="evaluate" /> -->
  </div>
</template>
<script>
// import evaluate from "@/views/mobile/reportHtml315/components/evaluate/index.vue"; // 评价弹窗

import { zzeScene } from "@/axios/config.js";
let timer = null;
export default {
  name: "App",
  data() {
    return {
      eveTime: 60,
    };
  },
  components: {
    // evaluate,
  },
  mounted() {
    // timer = setInterval(() => {
    //   this.eveTime -= 1;
    //   if (this.eveTime <= 0) {
    //     clearInterval(timer);
    //     if (
    //       this.$store.state.hasEvaluate == false &&
    //       this.$route.path != "/creatStory" &&
    //       this.$route.path != "/login" &&
    //       this.$store.state.userId != "" && 
    //       this.$store.state.userId != "999999999" &&
    //       !this.$route.query.fromZZJ
    //     ) {
    //       this.$refs.evaluate.showPop = true;
    //     }
    //     return;
    //   }
    //   if (
    //     this.$store.state.zztoken &&
    //     this.eveTime == 15 &&
    //     this.$route.path != "/creatStory" &&
    //     this.$route.path != "/login"
    //   ) {
    //     const params = {
    //       token: this.$store.state.zztoken,
    //       projectCode: this.$store.state.pjcode,
    //       userId: this.$store.state.userId,
    //     };
    //     zzeScene(params).then((res) => {
    //       // console.log(res);
    //     });
    //   }
    // }, 1000);
  },
  beforeDestroy() {
    // clearInterval();
  },
  methods: {
    setSize() {
      var clientWidth = document.documentElement.clientWidth;
      // if (clientWidth >= 750) {
      //     clientWidth = 750
      // }
      var fontSize = clientWidth / 100; // 乘以100是为了方便计算
      window.document.documentElement.style.fontSize = fontSize + "px";
    },
  },
  beforeMount() {
    this.setSize();
    window.addEventListener("resize", this.setSize);
  },
  computed: {
    autoScale() {
      return this.$store.state.autoScale;
    },
  },
  watch: {
    autoScale(val) {
      if (val) {
        window.addEventListener("resize", this.setSize);
      } else {
        window.removeEventListener("resize", this.setSize);
        window.document.documentElement.style.fontSize = "4.4px";
      }
    },
  },
};
</script>
<style lang="less">
@import "style/base";
@font-face {
  font-family: "Lato";
  src: url("./fonts/Lato-Bold.ttf") format("truetype");
  font-weight: bold;
}
html {
  scroll-behavior: smooth;
  font-family: "Lato";
}
body {
  margin: 0;
  padding: 0;
  -webkit-text-size-adjust: none !important;
  text-size-adjust: none !important;
  font-family: "Lato" !important;
}
img {
  // pointer-events: none;
}
::-webkit-scrollbar {
  width: 0;
  height: 0;
}
/* Firefox 浏览器 */
* {
  scrollbar-width: none;
}
</style>
